import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import Util from '../../forecast-app/shared/util/util';
import ResetCompanyToExpiredTrialMutation from '../../mutations/mission_control/reset_company_to_expired_trial_mutation';

class CompaniesWithoutActiveSubscriptions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// Company ids that have been reset to an expired trial during this session. They are
			// filtered out of the list because their tier is now TRIAL, which no longer matches the
			// paying-tier filter the backend list is built from.
			resetCompanyIds: new Set(),
		};
	}

	resetToExpiredTrial(company) {
		const confirmed = window.confirm(
			`Reset "${company.name}" (id ${company.companyId}) to an expired trial?\n\n` +
				'This sets the tier to TRIAL and clears the cached seats, cached virtual seats and Chargebee id.'
		);
		if (!confirmed) {
			return;
		}

		Util.CommitMutation(ResetCompanyToExpiredTrialMutation, {companyId: company.companyId}, () => {
			this.setState(prevState => {
				const resetCompanyIds = new Set(prevState.resetCompanyIds);
				resetCompanyIds.add(company.companyId);
				return {resetCompanyIds};
			});
		});
	}

	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		const style = {position: 'sticky', top: 0, background: 'white'};
		const allData = this.props.viewer.missionControlData.companiesWithoutActiveSubscriptions;
		const data = allData.filter(company => !this.state.resetCompanyIds.has(company.companyId));

		return (
			<div className="mission-control-list">
				<h1>Companies Without Active Subscriptions</h1>
				<div>Showing {data.length} companies</div>
				<table>
					<tbody>
						<tr>
							<th style={style}>Id</th>
							<th style={style}>Name</th>
							<th style={style}>Tier</th>
							<th style={style}>Created At</th>
							<th style={style}>Updated At</th>
							<th style={style}>Last Session Date</th>
							<th style={style}>Is Sage PSA Company</th>
							<th style={style}>Action</th>
						</tr>
						{data.map(company => (
							<tr key={company.companyId}>
								<td>{company.companyId}</td>
								<td>
									{company.salesforceAccountId ? (
										<a
											href={`https://forecasttechnologies.lightning.force.com/lightning/r/Account/${company.salesforceAccountId}/view`}
											target="_blank"
											rel="noopener noreferrer"
										>
											{company.name}
										</a>
									) : (
										company.name
									)}
								</td>
								<td>{company.tier}</td>
								<td>{company.createdAt}</td>
								<td>{company.updatedAt}</td>
								<td>{company.lastSessionDate}</td>
								<td>{company.isSagePSACompany ? 'Yes' : 'No'}</td>
								<td>
									<button onClick={() => this.resetToExpiredTrial(company)}>Reset to expired trial</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}
}

const companiesWithoutActiveSubscriptionsQuery = graphql`
	query companiesWithoutActiveSubscriptions_Query {
		viewer {
			actualPersonId
			component(name: "control_companies_without_active_subscriptions")
			...companiesWithoutActiveSubscriptions_viewer
		}
	}
`;

export {companiesWithoutActiveSubscriptionsQuery};

export default createFragmentContainer(withRouter(CompaniesWithoutActiveSubscriptions), {
	viewer: graphql`
		fragment companiesWithoutActiveSubscriptions_viewer on Viewer {
			id
			actualPersonId
			missionControlData {
				id
				companiesWithoutActiveSubscriptions {
					id
					companyId
					name
					tier
					createdAt
					updatedAt
					lastSessionDate
					isSagePSACompany
					salesforceAccountId
				}
			}
		}
	`,
});
